<template>
  <div class="menus-page display-col" >
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="table" class="full-height display-col">
        <el-row class="flex1 overflowAuto">
          <el-col :span="8" class="menu-list-container">
            <div class="menu-list">
              <el-tree
                  :data="data"
                  node-key="menuId"
                  :default-expanded-keys="['00000000-0000-0000-0000-000000000000']"
                  :props="defaultProps"
                  :expand-on-click-node = "false"
                  :check-on-click-node = "true"
                  :highlight-current = "true"
                  @node-drag-end="handleDragEnd">
            <span class="custom-tree-node" slot-scope="{ node, data }"  @click="() => selectedNode(node, data)">
              <span>{{ node.label }}</span>
              <span>
                <el-button
                    type="text"
                    size="mini"
                    @click="() => append(data)">
                  添加
                </el-button>
                <!-- <el-button
                  type="text"
                  size="mini"
                  @click="() => remove(node, data)">
                  删除
                </el-button> -->
              </span>
            </span>
              </el-tree>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="menu-form">
              <el-form
                  :model="menuForm"
                  label-width="120px"
                  class="menu-form"
                  style="max-width:500px"
              >
                <div style="padding:15px;font-size:15px;">
                  菜单修改
                </div>
                <el-form-item label="菜单名称：">
                  <el-input v-model="menuInfo.menuName" size="small"></el-input>
                </el-form-item>
                <el-form-item label="菜单图标：">
                  <el-input v-model="menuInfo.menuIcon" size="small"></el-input>
                </el-form-item>
                <el-form-item label="菜单路由：">
                  <el-input v-model="menuInfo.menuUrl" size="small"></el-input>
                </el-form-item>
                <el-form-item label="菜单顺序：">
                  <el-input v-model="menuInfo.sortKey" size="small" type="number"></el-input>
                </el-form-item>
                <el-form-item label="按钮权限：">
                  <el-button class="form-btn btn-blue" @click="dialogShow(menuInfo.btnAuth)" type="primary">编辑按钮权限</el-button>
                </el-form-item>
                <el-form-item label="删除状态：">
                  <el-checkbox v-model="isDelMenu" @change="delMenu()">选中为删除</el-checkbox>
                </el-form-item>
                <div class="save-btn-container">
                  <el-button class="form-btn btn-gray" @click="formReset">重 置</el-button>
                  <el-button class="form-btn btn-blue" @click="formSave" >提 交</el-button>
                </div>
              </el-form>
            </div>
          </el-col>
          <el-dialog title="菜单按钮权限" :visible.sync="dialogVisible">

            <div class="save-btn-container">
              <el-button size="small" @click="addAuth" type="success">添加</el-button>
            </div>
            <el-table ref="singleTable" :data="menuInfo.btnAuth" border=""  @selection-change="selectionChangeHandle" style="width: 100%;" height="550">
              <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>  -->
              <el-table-column label="权限名称" prop="permissionName">
                <template slot-scope="scope">
                <span v-show="scope.row.isEdit">
                    <el-input v-model="scope.row.permissionName" size="small"></el-input>
                </span>
                  <span v-show="!scope.row.isEdit">
                    {{scope.row.permissionName}}
                </span>
                </template>
              </el-table-column>
              <el-table-column label="权限标志" prop="permission">
                <template slot-scope="scope">
                <span v-show="scope.row.isEdit">
                    <el-input v-model="scope.row.permission" size="small"></el-input>
                </span>
                  <span v-show="!scope.row.isEdit">
                    {{scope.row.permission}}
                </span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button v-if="menuInfo.btnAuth.length>0" class=" btn-deepblue" @click="editAuth(scope.row)">编辑</el-button>
                  <el-button v-if="menuInfo.btnAuth.length>0"  class="list-btn btn-red" @click="deleteAuth(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="save-btn-container">
              <el-button class="form-btn btn-gray" @click="cancelEditAuth()">取 消</el-button>
              <el-button class="form-btn btn-blue" @click="saveEditAuth()">保 存</el-button>
            </div>

          </el-dialog>
        </el-row>
      </div>
    </table-con>












  </div>
  
</template>

<script>
let id = 1000;
export default {
  data() {
      return {
        data: [],
        defaultProps: {
          children: 'menuTreeChild',
          label: 'menuName',
          id:'menuId'
        },
        menuForm:{},
        menuInfo:{
          menuId: '',
          menuName: '',
          menuUrl:'',
          menuIcon:'',
          role:'',
          btnAuth:[{
            isEdit:false,
            permissionName:'',
            permission:''
          }],
          parentMenuId:'',
          // parentMenuName:'',
          sortKey:'',
          // menuTreeChild:[],
          delFlag:0,
        },
        selectedNodeData:{},
        dialogVisible:false,
        // menuBtnAuth:[],
        menuBtnAuthOrgin:[],
        isDelMenu:false,
        
      }
  },
  methods: {
    append(data) {
      const newChild = { 
        menuName: '新增菜单',
        // menuTreeChild: [],
        menuUrl:'',
        menuIcon:'',
        role:'',
        btnAuth:[{
          isEdit:false,
          permissionName:'',
          permission:''
        }],
        parentMenuId:data.menuId,
        sortKey:'',
        delFlag:0,
      };
      console.log(newChild);
      if (!data.menuTreeChild) {
        this.$set(data, 'menuTreeChild', []);
      }
      data.menuTreeChild.push(newChild);
    },

    remove(node, data) {
      const parent = node.parent;
      const menuTreeChild = parent.data.menuTreeChild || parent.data;
      const index = menuTreeChild.findIndex(d => d.menuId === data.menuId);
      menuTreeChild.splice(index, 1);
    },
    selectedNode(node,data){
      var _this = this;
      this.selectedNodeData = JSON.parse(JSON.stringify(data));
      if(this.selectedNodeData.btnAuth){
         this.selectedNodeData.btnAuth.forEach(el=>{
          _this.$set(el,'isEdit',false);
        })
      }
      var info  = JSON.parse(JSON.stringify(this.selectedNodeData));
      this.menuInfo = {
        menuId: info.menuId,
        menuName: info.menuName,
        menuUrl:info.menuUrl,
        menuIcon:info.menuIcon,
        role:info.role,
        btnAuth:info.btnAuth,
        parentMenuId:info.parentMenuId,
        sortKey:info.sortKey,
        delFlag:info.delFlag,
      };
      this.isDelMenu = this.menuInfo.delFlag !== '0';
    },
    handleDragEnd(e){
      console.log('end');
      console.log(this.data);
    },
    dialogShow(){
      var _this = this;
      this.dialogVisible = true;
      if(this.menuInfo.btnAuth && this.menuInfo.btnAuth.length>0){
        this.menuInfo.btnAuth.forEach(el=>{
          el.isEdit = false;
        })
      }
      if(this.menuInfo.btnAuth && this.menuInfo.btnAuth.length>0){
        this.menuBtnAuthOrgin = JSON.parse(JSON.stringify(this.menuInfo.btnAuth)); 
      }
    },
    selectionChangeHandle(e){
      console.log(e);
    },
    addAuth(){
      this.menuInfo.btnAuth.push({
        isEdit:true,
        permissionName:'',
        permission:''
      })
    },
    editAuth(row){
      if(row){
        row.isEdit = true;
      }
    },
    cancelEditAuth(){
      this.menuInfo.btnAuth = JSON.parse(JSON.stringify(this.menuBtnAuthOrgin)); 
      this.menuInfo.btnAuth.forEach(el=>{
        el.isEdit = false;
      });
      this.dialogVisible = false;
    },
    saveEditAuth(){
      this.menuInfo.btnAuth.forEach(el=>{
        el.isEdit = false;
      });
      this.dialogVisible = false;
    },
    deleteAuth(row){
      //  首先需要确定需要删除元素的索引值。
      Array.prototype.indexOf = function (val) {
        for(var i = 0; i < this.length; i++){
          if(this[i] == val){return i;}
        }
        return -1;
      }
      // 根据索引值删除数组中该元素对应的值
      Array.prototype.remove = function (val) {
        var index = this.indexOf(val);
        if(index > -1){this.splice(index,1);}
      }
      console.log(this.menuInfo.btnAuth);
      this.menuInfo.btnAuth.remove(row);
    },
    delMenu(){
      if(this.isDelMenu == false){
        this.menuInfo.delFlag = '0';
      }
      else{
       this.menuInfo.delFlag = '1';
      }
      console.log(this.menuInfo);
    },
    formReset(){
      this.menuInfo = JSON.parse(JSON.stringify(this.selectedNodeData));
    },
    formSave(){
      console.log(this.menuInfo);
      this.saveForm();
    },
    async saveForm(){
      if(this.menuInfo.menuId){
        var {data:res} = await this.$http.post('menu/update',this.menuInfo);
        if(res.code == 200){
          this.$message({
            type:'success',
            message:res.message
          })
        }
        else{
          this.$message({
            type:'error',
            message:res.message
          })
        }
        this.getMenuList();
      }
      else{
        var {data:res} = await this.$http.post('menu/create',this.menuInfo);
        if(res.code == 200){
          this.$message({
            type:'success',
            message:res.message
          })
        }
        else{
          this.$message({
            type:'error',
            message:res.message
          })
        }
        this.getMenuList();
      }
    },
    async getMenuList(){
      const {data:res}  = await this.$http.get('menu/treeList');
      console.log('list');
      console.log(res);
      if(res.code == 200){
        this.data = JSON.parse(JSON.stringify(res.data));
      }
    },
  },
  created() {
    this.getMenuList();
  }
};
</script>

<style lang="less" scoped>
  .menus-page{
    width: 100%;
    height: 100%;
  }
  .el-col{
    height: 100%;
  }
  .menu-list-container{
    padding-right: 10px;
  }
  .menu-list,.menu-form{
    height: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    overflow: auto;
  }
   .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .save-btn-container{
    text-align: center;
    padding: 10px;
  }
  
</style>